import config from '@feature-config/productivity/workflow-builder/feature.config.json';
import { createFeatureModule } from '../../createFeatureModule';
import type { FeatureModule } from '../../types';
import WorkflowBuilder from './WorkflowBuilderFeature';

const workflowBuilderFeature: FeatureModule = createFeatureModule(
  config,
  WorkflowBuilder,
  'productivity/workflow-builder'
);

export default workflowBuilderFeature;
